const SEARCH_PATH = document.documentElement.dataset.coutureiaSearchPath || '/search';

function localizedPagePath(handle) {
  const prefix = SEARCH_PATH.endsWith('/search') ? SEARCH_PATH.slice(0, -7) : '';
  return `${prefix}/pages/${handle}`.replace(/\/{2,}/g, '/');
}

function normalizeLabel(value) {
  return String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('de');
}

function rewriteGermanHubAnchor(anchor) {
  if (!(anchor instanceof HTMLAnchorElement)) return;
  if (!anchor.closest('nav[header-menu]') || anchor.closest('.menu-list__submenu')) return;

  const label = normalizeLabel(anchor.textContent);
  if (label === 'männer' || label === 'maenner') {
    anchor.href = localizedPagePath('men');
    anchor.dataset.coutureiaLocaleHubFix = 'men';
  } else if (label === 'frauen') {
    anchor.href = localizedPagePath('women');
    anchor.dataset.coutureiaLocaleHubFix = 'women';
  }
}

function rewriteGermanHubLinks(root = document) {
  root.querySelectorAll?.('nav[header-menu] a[href]').forEach(rewriteGermanHubAnchor);
}

if (document.documentElement.dataset.coutureiaSearchFirst === 'true') {
  rewriteGermanHubLinks();
  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (anchor) rewriteGermanHubAnchor(anchor);
  }, true);

  new MutationObserver(() => rewriteGermanHubLinks()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}
